const iqr = (k) => {
  return (d, i) => {
    let q1 = d.quartiles[0],
      q3 = d.quartiles[2],
      iqr = (q3 - q1) * k,
      j = d.length;
    // CHECK: Why attributing a value here ???
    i = -1;

    while (d[++i] < q1 - iqr);
    while (d[--j] > q3 + iqr);

    return [i, j];
  };
}

export default iqr;
